"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getColumnsHandlerTypeId = getColumnsHandlerTypeId;
const DynamicColumnConfigProvider_1 = require("../components/DynamicColumnConfigProvider");
function getColumnsHandlerTypeId(provider, filterOptions) {
    return (0, DynamicColumnConfigProvider_1.defineColumnHandler)({
        name: provider.type,
        label: provider.label,
        columnType: 'id',
        arrayColumnType: 'id-array',
        filterOptions,
        format: (columnValue, data) => {
            if (columnValue) {
                return data.get(columnValue) ?? columnValue;
            }
            else {
                return undefined;
            }
        },
        formatArray: (columnValue, data) => {
            return columnValue ? columnValue.map((value) => data.get(value)).join('; ') : undefined;
        },
        loadData: () => provider.getValues({}).then((resp) => resp.reduce((prev, current) => prev.set(current.value, current.label), new Map())),
    });
}
